import styles from './ProjectInformation.module.scss';
import { ReactElement } from 'react';

export interface ProjectInformationProps {
  projectInformation: { title: string; icon: ReactElement; text: string | ReactElement }[];
}

export const ProjectInformation = ({ projectInformation }: ProjectInformationProps) => {
  return (
    <div className={styles.projectInformationContainer}>
      {projectInformation.map(({ title, icon, text }, index) => (
        <div className={styles.projectInformationItem} key={index}>
          <span>{title}</span>
          <div className={styles.iconText}>
            {icon}
            <span>{text}</span>
          </div>
        </div>
      ))}
    </div>
  );
};
